/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import FormSelect from "../formSelect/formSelect";
import FormInputText from "../formInputText/formInputText";
import { httpGet } from "../../../store/externalCalls/httpCalls";
import { getIframeSizes } from "../../../utils/canvasUtils";

import "./formInteractableGraphics.scss";
import FormCheckbox from "../formCheckbox/formCheckbox";
import { useSelector, shallowEqual } from 'react-redux';
import { storeStructure } from '../../../store/reducers';

const FormInteractableGraphics = ({
  id,
  name,
  place,
  value,
  hidden,
  onUpdateInteractable,
}) => {
  const childRef = useRef();
  const [interactableValue, setInteractableValue] = useState([]);
  const [interactableSelected, setInteractableSelected] = useState(null);
  const [options, setOptions] = useState([]);
  const [finalUrl, setFinalUrl] = useState("");
  const [customUrl, setCustomUrl] = useState("");
  const [rawUrl, setRawUrl] = useState("");
  const [customForm, setCustomForm] = useState(false);
  const [width, setWidth] = useState("");
  const [paramsValue, setParamsValue] = useState({});
  const [modesAvailable, setModesAvailable] = useState([]);
  // Helpers
  const hasValue = (v) =>
    v !== undefined && v !== null && String(v).trim() !== "";

  const encodePathSegment = (val) =>
    encodeURIComponent(val).replace(/%2F/g, "/");

  const normalizeParamLabel = (param) =>
    param.replace(/\?/g, "").replace(/^\w/, (c) => c.toUpperCase());

  const buildUrlFromTemplate = (template, params) => {
    if (!template) return "";
    let url = template; 

    for (const [rawKey, valRaw] of Object.entries(params)) {
      const key = rawKey.replace(/\?$/, ""); 
      let val = valRaw;

      if (hasValue(val)) {
        if (key === "configId" || key === "sportroom") val = Number(val);
        const regex = new RegExp(`#${key}\\??#`, "g");
        url = url.replace(regex, encodeURIComponent(val));
      } else {
        const regex = new RegExp(`#${key}\\??#`, "g");
        url = url.replace(regex, "");
      }
    }
    url = url.replace(/#\w+\??#/g, "");
    url = url.replace(/\/{2,}/g, "/");
    url = url.replace(/\?$/g, "");

    return url;
  };
  const session = useSelector(
      (state) => state[storeStructure.Session],
      shallowEqual
    );
    const isAndroidXR = session?.platform === "androidXR";
     const [height, setHeight] = useState(() => {
    if (value?.height) return value.height;
    return isAndroidXR ? 306 : "";
  });

  ;
  useEffect(() => {
    if (value) loadSelected(value.id, false, value);
  }, [value]);

  const loadSelected = (selectedId, update = true, extValue = null) => {
    setInteractableSelected(selectedId);
    if (Number(selectedId) === 9999999999999) {
      setCustomForm(true);
      setWidth(416);
      setHeight(extValue?.height || 306);
      if (extValue?.url) setCustomUrl(extValue.url);
      return;
    }

    setCustomForm(false);

    httpGet("interactableGraphicProperties/" + selectedId)
      .then((res) => {
        const keys = JSON.parse(res.params || "[]");

        const initialParams = {};
        keys.forEach((key) => {
          let val = extValue?.values?.[key] || "";
          if ((key === "configId" || key === "sportroom") && val !== "")
            val = Number(val);
          initialParams[key] = val;
        });

        const modes = res.modesAvailable || [];
        if (modes.length > 0) {
          initialParams["mode?"] = extValue?.values?.["mode?"] || "";
          setModesAvailable(modes);
        } else {
          setModesAvailable([]);
        }

        setParamsValue(initialParams);
        setRawUrl(res.url);
        setInteractableValue(res);

        const finalPath = buildUrlFromTemplate(res.url, initialParams);
        const finalFullUrl = process.env.REACT_APP_BACKEND_URL + finalPath;
        setFinalUrl(finalFullUrl);
        setCustomUrl(finalFullUrl);
        const sizes = getIframeSizes(res.sizes);
        if (update)
          onUpdateInteractable({
            id: res.id,
            url: finalFullUrl,
            params: Object.keys(initialParams),
             values: {
      ...initialParams,
              height: extValue?.height || (sizes ? sizes[1] : (isAndroidXR ? 306 : 416)),
              scalingFactor: extValue?.scalingFactor || 1, 
    },
          });
        
        if (sizes) {
          setWidth(sizes[0]);
          setHeight(extValue?.height || (sizes ? sizes[1] : (isAndroidXR ? 306 : 416)));
        }
      })
      .catch((err) => console.error("loadSelected - error:", err));
  };

  const handleChangeInteractable = (e) => {
    setFinalUrl("");
    loadSelected(e.target.value);
  };

  const handlerCustomChange = (e) => {
    setCustomUrl(e.target.value);
    onUpdateInteractable({
      id: 9999999999999,
      url: e.target.value,
      params: null,
      values: null,
    });
  };

 const handlerParamChange = (e, param) => {
  let val = e.target.value;
  if ((param === "configId" || param === "sportroom") && val !== "") {
    val = Number(val);
  }

  const newParams = { ...paramsValue, [param]: val };
  setParamsValue(newParams);

  if (!rawUrl) return;

  const finalPath = buildUrlFromTemplate(rawUrl, newParams);
  const finalFullUrl = process.env.REACT_APP_BACKEND_URL + finalPath;
  setFinalUrl(finalFullUrl);
  setCustomUrl(finalFullUrl);

  const updatedValues = {
    ...newParams,
  };

  onUpdateInteractable({
    id: interactableSelected,
    url: finalFullUrl,
    params: Object.keys(updatedValues),
    values: updatedValues,
  });
};

const handleHeightChange = (e) => {
  const newHeight = Number(e.target.value);
  setHeight(newHeight);

  if (!interactableValue) return;

  const updatedInteractable = {
    ...interactableValue,
    values: {
      ...interactableValue.values,
      height: newHeight,
      scalingFactor: interactableValue.scalingFactor || 1,
    },
  };

  setInteractableValue(updatedInteractable);

  onUpdateInteractable({
    id: interactableSelected,
    url: customUrl,
    params: Object.keys(updatedInteractable.values),
    values: updatedInteractable.values,
    interactableGraphicSelector: updatedInteractable,
  });
};


  //console.log("IG", interactableValue);
  //console.log('se', session)

  return (
    <div
      className={`interactableGraphicform-group row ${
        hidden ? "form-input-text__hidden" : ""
      }`}
    >
      <FormSelect
        id={id}
        label={name}
        ref={childRef}
        options={options}
        value={interactableSelected}
        emptyValue={true}
        url={"interactableGraphicList/" + place}
        default={"(Empty)"}
        asyncSelect={true}
        fieldValue={"id"}
        fieldName={"name"}
        onChange={handleChangeInteractable}
      />

      {!customForm && interactableValue && (
        <div className="interactableGraphic-block">
          <div className="interactableGraphic-params">
            Name: <b>{interactableValue.name}</b>
            <br />
            Sizes available: <b>{interactableValue.sizes}</b>
            {interactableValue.params &&
              JSON.parse(interactableValue.params).map((el, index) => (
                <div key={"interactableElem" + index}>
                  {el.toLowerCase() === "mode?" ? (
                    <FormCheckbox
                      title="Schedule & Favorites Display"
                      label="Schedule & Favorites Display"
                      placeholder="Show only Favorites when no scheduled live events are available"
                      helpText={`Determines whether to show the schedule tab or only favorites.
If enabled → show only Favorites (schedule hidden when no live events exist).
If disabled → show both Schedule and Favorites tabs, even if no live events are scheduled.`}
                      checked={paramsValue["mode?"] === "favorites"}
                      onChange={() =>
                        handlerParamChange(
                          {
                            target: {
                              value:
                                paramsValue["mode?"] === "favorites"
                                  ? ""
                                  : "favorites",
                            },
                          },
                          "mode?" 
                        )
                      }
                    />
                  ) : el.toLowerCase() === "configid" ? (
                    <FormInputText
                      id={"configId" + index}
                      key={"interactableConfigId" + index}
                      name={el}
                      placeholder="Enter the Config ID"
                      helpText="(Required) Unique identifier for this configuration. Enter exactly one valid Config ID."
                      type="test"
                      value={paramsValue[el] || ""}
                      title="Config ID"
                      label="Config ID"
                      onChange={(e) => handlerParamChange(e, el)}
                    />
                  ) : el.toLowerCase() === "sportroom?" ? (
                    <FormInputText
                      id={"sportroom" + index}
                      key={"interactableSportroom" + index}
                      name={el}
                      placeholder="Enter the Space ID"
                      helpText="(Optional) If selected, this sport room will appear as the default filter in the schedule view.
                      Users will see events only from this space by default. Only one space can be set."
                      type="text"
                      value={paramsValue[el] || ""}
                      title="Default Sport Room"
                      label="Space ID"
                      onChange={(e) => handlerParamChange(e, el)}
                    />
                  ) : (
                    <FormInputText
                      id={"url" + index}
                      key={"interactableUrl" + index}
                      name={el}
                      placeholder={"insert a valid value"}
                      helpText={"Type a valid value"}
                      type="text"
                      value={paramsValue[el] || ""}
                      label={normalizeParamLabel(el)}
                      onChange={(e) => handlerParamChange(e, el)}
                    />
                  )}
                </div>
              ))}
              {isAndroidXR && (
  <FormInputText
    id="height"
    key="interactableHeight"
    name="height"
    type="number"
    label="Height"
    placeholder="Enter height in px"
    value={height}
    helpText="Set the height for Android XR canvas elements"
    onChange={handleHeightChange}
    autocomplete="off"
  />
)}
          </div>

          {finalUrl && (
            <div className="interactableGraphic-preview">
              <label>Preview</label>
              <br />
              <iframe src={finalUrl} width={width} height={height} />
              <br />
              {finalUrl}
              <br />
              <div>
                <a href={finalUrl} target="_blank">
                  Open in a new window
                </a>
              </div>
            </div>
          )}
        </div>
      )}

      {customForm && (
        <div className="interactableGraphic-block">
          <FormInputText
            id={"url"}
            key={"interactableUrl"}
            name={"Url"}
            placeholder={"Url of the interactable"}
            helpText={"Type a valid url"}
            type={"text"}
            value={customUrl}
            label={"Url"}
            onChange={handlerCustomChange}
            autocomplete="off"
          />
          {customUrl && (
            <div className="interactableGraphic-preview">
              <label>Preview</label>
              <br />
              <iframe src={customUrl} width={width} height={height} />
              <br />
              {customUrl}
              <br />
              <div>
                <a href={customUrl} target="_blank">
                  Open in a new window
                </a>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

FormInteractableGraphics.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
  value: PropTypes.any,
  onUpdateInteractable: PropTypes.func.isRequired,
};

export default FormInteractableGraphics;
